__webpack_require__.p = "https://admin.cordialhotel.com.vn/";